import { render, staticRenderFns } from "./booking-card-list-skeleton-loader.vue?vue&type=template&id=8b396476&"
import script from "./booking-card-list-skeleton-loader.vue?vue&type=script&lang=js&"
export * from "./booking-card-list-skeleton-loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports